export default "__VITE_ASSET__B64ygQ7D__"